import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import axios from 'axios'
import './SignupNormal.scss'
import HeaderLogin from '../../Components/Commons/HeaderLogin'
import ServiceTerms from '../../Components/Policy/ServiceTerms'
import PrivacyTerms from '../../Components/Policy/PrivacyTerms'
import PreparedProjects from '../../Components/User/PreparedProjects'
import SignComplete from '../../../Res/img/sign_complete.png'
import queryString from 'query-string'
import { withCookies, Cookies } from 'react-cookie'

class SignupNormal extends Component {
    constructor(props, context) {
        super(props, context)
        this.redirectUrl = '/'

        this.state = {
            user: {
                email: '',
                name: '',
                password: '',
                passwordConfirm: '',
                phoneNumber: '',
            },

            termCheck: {
                checked1: false,
                checked2: false,
                checkedAll: false,
            },
            emailResult: '',
            complete: false,
            preparedProjects: [],
            referrer: 'hausplanner',
        }
    }

    UNSAFE_componentWillMount() {
        const query = queryString.parse(this.props.location.search)
        if (query.redirect) {
            this.redirectUrl = query.redirect
        }
        this.loadCookie()
    }

    loadCookie = () => {
        const appName = this.props.cookies.get('app_name')
        if (appName && appName !== '') {
            this.setState({
                referrer: appName,
            })
        }
    }

    emailCheck = () => {
        const regExp = /[0-9a-zA-Z][_0-9a-zA-Z-]*@[_0-9a-zA-Z-]+(\.[_0-9a-zA-Z-]+){1,2}$/

        if (this.state.user.email === '') {
            alert('이메일을 입력해주세요.')
        } else if (!this.state.user.email.match(regExp)) {
            alert('이메일 형식이 올바르지 않습니다.')
        } else {
            axios
                .get(`${BACKEND_HOST}/users/email-check?email=${this.state.user.email}`)
                .then((res) => {
                    console.log(res.data)
                    this.setState({
                        emailResult: !res.data.duplication,
                    })
                })
                .catch((err) => {
                    console.log(err)
                })
        }
    }

    changeUser = (event) => {
        const field = event.target.name
        const user = this.state.user
        if (field === 'email') {
            user['email'] = event.target.value.trim().toLowerCase()
            this.setState({
                emailResult: '',
            })
        } else {
            user[field] = event.target.value
        }

        this.setState({
            user,
        })
    }

    handleCheckbox = (event) => {
        const field = event.target.name

        if (field === 'checkedAll') {
            const checked = this.state.termCheck
            checked['checkedAll'] = event.target.checked
            checked['checked1'] = event.target.checked
            checked['checked2'] = event.target.checked

            this.setState({
                checked,
            })
        } else {
            const checked = this.state.termCheck
            checked[field] = event.target.checked

            this.setState({
                checked,
            })
        }
    }

    sendDataOwner = (event) => {
        event.preventDefault()
        if (this.state.user.email === '') {
            alert('이메일을 입력해주세요.')
            return
        } else if (this.state.user.name === '') {
            alert('이름을 입력해주세요.')
            return
        } else if (this.state.user.password === '') {
            alert('비밀번호를 입력해주세요.')
            return
        } else if (this.state.user.passwordConfirm === '') {
            alert('비밀번호 재확인을 입력해주세요.')
            return
        } else if (this.state.user.phoneNumber === '') {
            alert('휴대폰번호를입력해주세요.')
            return
        } else if (!this.state.emailResult) {
            alert('이메일 중복 확인을 해주세요.')
            return
        } else if (this.state.user.password !== this.state.user.passwordConfirm) {
            alert('비밀번호가 일치하지 않습니다.')
            return
        } else if (!this.state.termCheck.checked1 || !this.state.termCheck.checked2) {
            alert('이용약관 동의를 해주세요.')
            return
        }

        axios
            .post(`${BACKEND_HOST}/auth/signup`, {
                email: this.state.user.email,
                phoneNumber: this.state.user.phoneNumber,
                password: this.state.user.password,
                name: this.state.user.name,
                group: 'CLIENT',
                region: 'KR',
                servicePolicyAgree: true,
                privacyPolicyAgree: true,
                marketingAgree: true,
                referrer: this.state.referrer,
            })
            .then((res) => {
                console.log(res)
                this.setState({
                    complete: true,
                    // preparedProjects: res.data.data.preparedProjects,
                })
            })
            .catch((err) => {
                console.log(err)
                alert(err.message)
            })
    }

    render() {
        //console.log(this.state)

        //비번 길이 확인
        let passwordMsg = ''
        let passwordLength = false

        if (this.state.user.password !== '') {
            if (this.state.user.password.length < 8 || this.state.user.password.length > 15) {
                passwordMsg = '비밀번호는 8~15자리를 사용해야 합니다.'
                passwordLength = false
            } else {
                passwordMsg = '사용 가능한 비밀번호입니다.'
                passwordLength = true
            }
        }

        //비번 일치 확인
        let passwordConfirmMsg = ''
        let passwordConfirm = false

        if (this.state.user.password !== '' && this.state.user.passwordConfirm !== '') {
            if (this.state.user.password !== this.state.user.passwordConfirm) {
                passwordConfirmMsg = '비밀번호가 일치하지 않습니다.'
                passwordConfirm = false
            } else {
                passwordConfirmMsg = '비밀번호가 일치합니다.'
                passwordConfirm = true
            }
        }

        //이메일 중복 확인
        let emailCheckMsg = '이메일 입력 후 중복확인을 해주세요.'

        if (this.state.emailResult === true) {
            emailCheckMsg = '사용 가능한 이메일입니다.'
        } else if (this.state.emailResult === false) {
            emailCheckMsg = '중복된 이메일입니다.'
        }

        //가입 버튼 활성화
        let joinButton = false

        if (
            this.state.user.email !== '' &&
            this.state.user.name !== '' &&
            this.state.user.password !== '' &&
            this.state.user.passwordConfirm !== '' &&
            this.state.user.phoneNumber !== ''
        ) {
            if (
                this.state.emailResult &&
                this.state.user.password === this.state.user.passwordConfirm &&
                this.state.termCheck.checked1 &&
                this.state.termCheck.checked2
            ) {
                // if (this.state.addInfo.address !== '' && this.state.addInfo.family1 !== '' && this.state.addInfo.family2 !== '' && this.state.addInfo.family3 !== ''
                // && this.state.addInfo.buildType !== '' ){
                //   joinButton = true;
                // }
                joinButton = true
            }
        }

        return (
            <div>
                <HeaderLogin />
                <div className="section_wrap">
                    {this.state.complete === false ? (
                        <div className="signup_normal_wrap common_detail">
                            <div className="section section1">
                                <h1>회원가입</h1>
                                <form action="/" onSubmit={this.sendDataOwner}>
                                    <div className="input_wrap">
                                        <label>이메일</label>
                                        <div
                                            className={`check_btn ${this.state.user.email !== '' && 'btn_on'}`}
                                            onClick={this.emailCheck}>
                                            중복확인
                                        </div>
                                        <input
                                            className="input"
                                            type="text"
                                            name="email"
                                            onChange={this.changeUser}
                                            value={this.state.user.email}
                                        />
                                        <p className={`check_msg ${this.state.emailResult && 'msg_on'}`}>
                                            {emailCheckMsg}
                                        </p>
                                    </div>

                                    <div className="input_wrap">
                                        <label>이름</label>
                                        <input
                                            className="input"
                                            type="text"
                                            name="name"
                                            onChange={this.changeUser}
                                            value={this.state.user.name}
                                        />
                                    </div>

                                    <div className="input_wrap short_input short_input1">
                                        <label>비밀번호</label>
                                        <input
                                            className="input"
                                            type="password"
                                            name="password"
                                            onChange={this.changeUser}
                                            value={this.state.user.password}
                                        />
                                        <p className={`check_msg ${passwordLength && 'msg_on'}`}>{passwordMsg}</p>
                                    </div>

                                    <div className="input_wrap short_input">
                                        <label>비밀번호 재확인</label>
                                        <input
                                            className="input"
                                            type="password"
                                            name="passwordConfirm"
                                            onChange={this.changeUser}
                                            value={this.state.user.passwordConfirm}
                                        />
                                        <p className={`check_msg ${passwordLength && 'msg_on'}`}>
                                            {passwordConfirmMsg}
                                        </p>
                                    </div>

                                    <div className="input_wrap phone_wrap">
                                        <label>휴대폰</label>
                                        <input
                                            className="input"
                                            type="number"
                                            name="phoneNumber"
                                            onChange={this.changeUser}
                                            value={this.state.user.phoneNumber}
                                            placeholder="-없이 숫자만 입력"
                                        />
                                    </div>

                                    <div className="agree_wrap">
                                        <label className="checkbox_wrap">
                                            이용약관 전체 동의
                                            <input
                                                type="checkbox"
                                                name="checkedAll"
                                                onChange={this.handleCheckbox}
                                                checked={this.state.termCheck.checkedAll}
                                            />
                                            <span className="checkmark"></span>
                                        </label>
                                    </div>

                                    <button type="submit" className={`${joinButton && 'joinbtn_on'}`}>
                                        가입하기
                                    </button>
                                </form>
                            </div>

                            <div className="section section2">
                                <h2>
                                    <div className="green_line"></div>
                                    이용약관 동의
                                </h2>
                                <div className="agree_wrap">
                                    <label className="checkbox_wrap">
                                        서비스 이용약관 동의 (필수)
                                        <input
                                            type="checkbox"
                                            name="checked1"
                                            onChange={this.handleCheckbox}
                                            checked={this.state.termCheck.checked1}
                                        />
                                        <span className="checkmark"></span>
                                    </label>
                                    <ServiceTerms />
                                </div>

                                <div className="agree_wrap agree_wrap2">
                                    <label className="checkbox_wrap">
                                        개인정보 수집 및 이용약관 동의 (필수)
                                        <input
                                            type="checkbox"
                                            name="checked2"
                                            onChange={this.handleCheckbox}
                                            checked={this.state.termCheck.checked2}
                                        />
                                        <span className="checkmark"></span>
                                    </label>
                                    <PrivacyTerms />
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="signup_complete_wrap common_wrap">
                            <img src={SignComplete} alt="complete" />
                            <h1>회원가입이 완료되었습니다!</h1>
                            <p>서비스 이용은 하우스플래너에서 프로젝트 생성 후 가능합니다.</p>
                            <PreparedProjects projects={this.state.preparedProjects} />
                            <Link to={`/login/?redirect=${this.redirectUrl}`} replace>
                                <p className="login_btn">로그인 후 서비스 이용하기</p>
                            </Link>
                        </div>
                    )}
                </div>
            </div>
        )
    }
}

export default withCookies(SignupNormal)



// WEBPACK FOOTER //
// ./Src/Containers/Signup/SignupNormal.js